import { makeStyles, createStyles} from '@material-ui/core/styles';

export default makeStyles((theme) => createStyles({
  default: {
    padding: '80px 0'
  },
  isPrimary: {
    padding: '80px 0',
    backgroundColor: theme.palette.primary.main,
    overflowY: 'auto'
  },
  isSecondary: {
    padding: '80px 0',
    backgroundColor: theme.palette.secondary.main,
    overflowY: 'auto'
  },
  hasPadding:{
    padding: '80px 0'
  },
  isWhite:{
    padding: '40px 0'
  },
  topPadding: {
    paddingTop: '40px'
  },
  primaryBG: {
    backgroundColor: theme.palette.primary.main,
  },
  secondaryBG: {
    backgroundColor: theme.palette.secondary.main,
  },
  greyBG: {
    backgroundColor: '#f4f4f4'
  },
  aboutPageText: {
    textAlign: 'left',
    marginBottom: '2em',
    marginTop: '2em',
  }
}));